import { LinkPanelItem } from './componentsv2/cms/LinkPanel/LinkPanelItem';

export const UmbracoComponentMapping = {
    reactAccordion: require('./componentsv2/cms/Accordion').default,
    reactAppLinkContainer: require('./components/umbraco/AppLinkContainer').default,
    reactAvatarPlusText: require('./componentsv2/cms/AvatarPlusText').default,
    reactAvatarPlusTextSlider: require('./componentsv2/cms/AvatarPlusTextWithSlider').default,
    reactCalendar: require('./componentsv2/cms/EventCalendar').default,
    reactCarousel: require('./componentsv2/cms/ImageCarousel').default,
    reactCornerBlock: require('./componentsv2/cms/Cornerblock').default,
    reactCornerBlockCTA: require('./componentsv2/cms/Cornerblock/Cta').default,
    reactCornerBlockWYSIWYG: require('./componentsv2/cms/Cornerblock/WYSIWYG').default,
    reactCta: require('./componentsv2/cms/Cta').default,
    reactCTAContainer: require('./componentsv2/cms/CtaContainer').default,
    reactEmailSubscriptionForm: require('./componentsv2/cms/EmailSubscriptionForm').default,
    reactEmbeddedScript: require('./componentsv2/cms/EmbeddedScript').default,
    reactEvent: require('./componentsv2/cms/Event').default,
    reactEventsGrid: require('./componentsv2/cms/EventGrid').default,
    reactEventsScreen: require('./components/umbraco/EventScreen/EventScreen').default,
    reactFeaturedService: require('./componentsv2/cms/FeaturedService').default,
    reactFooter: require('./componentsv2/cms/SiteFooter').default,
    reactFormStackForm: require('./componentsv2/cms/FormStackForm').default,
    reactFullWidthImage: require('./componentsv2/cms/FullWidthImage').default,
    reactGiving: require('./componentsv2/cms/Giving').default,
    reactHorizontalGrid: require('./componentsv2/cms/HorizontalGrid').default,
    reactHowToWatchContainer: require('./componentsv2/cms/HowToWatch').default,
    reactIconPlusHeading: require('./componentsv2/cms/IconPlusHeading').default,
    reactImageWithDescription: require('./componentsv2/cms/ImageWithDescription').default,
    reactJob: require('./componentsv2/cms/Job').default,
    reactJobsContainer: require('./componentsv2/cms/JobsContainer').default,
    reactLinkPanel: require('./componentsv2/cms/LinkPanel').default,
    reactLinkPanelItem: LinkPanelItem,
    // reactListItem: ListItem,
    reactListItemContainer: require('./componentsv2/cms/ListItemContainer').default,
    reactMinistry: require('./componentsv2/cms/Ministry').default,
    reactMinistryGrid: require('./componentsv2/cms/MinistryGrid').default,
    reactNameAcquisition: require('./componentsv2/cms/NameAcquisition').default,
    reactNewsArticle: require('./componentsv2/cms/NewsArticle').default,
    reactNewsArticleCard: require('./componentsv2/cms/NewsArticleCard').default,
    reactNewsArticlesGrid: require('./componentsv2/cms/NewsArticleGrid').default,
    reactNewsArticleRelatedContent: require('./componentsv2/cms/NewsArticleRelated').default,
    reactNextLiveService: require('./componentsv2/cms/LiveService/LiveService').default,
    reactPhoto: require('./componentsv2/cms/Photo').default,
    reactPhotoGallery: require('./componentsv2/cms/PhotoGallery').default,
    reactPhotoGrid: require('./componentsv2/cms/PhotoGrid').default,
    reactService: require('./componentsv2/cms/ServiceBlock').default,
    reactServiceContainer: require('./componentsv2/cms/ServiceContainer').default,
    reactSocialLink: require('./componentsv2/cms/SocialLink').default,
    reactSocialLinksContainerWithCTA: require('./componentsv2/cms/SocialLinksContainerWithCta').default,
    reactSocialPostContainer: require('./componentsv2/cms/SocialPostContainer').default,
    reactSpacer: require('./componentsv2/cms/Spacer').default,
    reactTabbedAlternatingContainer: require('./componentsv2/cms/TabbedAlternatingContainer').default,
    reactTabbedContainer: require('./componentsv2/cms/TabbedContainer').default,
    reactTextPlusImage: require('./componentsv2/cms/TextPlusImage').default,
    reactTextPlusImageWithLink: require('./componentsv2/cms/TextPlusImageWithLink').default,
    reactTwoColumnWYSIWYG: require('./componentsv2/cms/TwoColumnWYSIWYG').default,
    reactVideoPlayer: require('./componentsv2/cms/Video').default,
    reactWYSIWYG: require('./componentsv2/cms/WYSIWYG').default
};